import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { txCenterQueries } from '@/queries/tx-centers';

export const txCentersLoader = (queryClient: QueryClient) => () => {
  return queryClient.ensureQueryData(txCenterQueries.list({ itemsPerPage: LIST_ITEMS_COUNT, pageIndex: 0 }));
};

export const txCenterByIdLoader = (queryClient: QueryClient) => (txCenterId: string) => {
  return queryClient.fetchQuery({
    ...txCenterQueries.itemWithTXUsers(txCenterId),
  });
};
